// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"cd8f0f71","787":"1791b68f"}[chunkId] + ".chunk.js";
};